import { useReducer, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useHttp from "../../../hooks/use-http";
import { authActions } from "../../../store/auth";
import Input from "../../UI/Input";
import { endPoints } from "../../../config/end-points";

import { useEffect } from "react";

import { saveLocalData } from "../../../helpers/storage-helper";
import { useHistory } from "react-router-dom";
import { cuteToast } from "../../UI/cute";

const emailReducer = (state, action) => {
  switch (action.type) {
    case "USER_INPUT":
      return {
        value: action.value,
        isValid: /\S+@\S+\.\S+/.test(action.value),
      };
    case "USER_INPUT_BLUR":
      return { value: state.value, isValid: /\S+@\S+/.test(state.value) };
    default:
      return { value: "", isValid: false };
  }
};

const passwordReducer = (state, action) => {
  switch (action.type) {
    case "USER_INPUT":
      return { value: action.value, isValid: action.value.trim().length > 6 };
    case "USER_INPUT_BLUR":
      return { value: state.value, isValid: state.value.trim().length > 0 };
    default:
      return { value: "", isValid: false };
  }
};

const Login = () => {
  const history = useHistory();
  const [emailState, dispatchEmail] = useReducer(emailReducer, {
    value: "",
    isValid: null,
  });
  const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
    value: "",
    isValid: null,
  });

  const subdomain_id = useSelector(state => state.auth.product.id)
  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  const meta_data = useSelector(state => state.auth.product.meta_data)

  const logo = meta_data && JSON.parse(meta_data).subdomainLogo ? JSON.parse(meta_data).subdomainLogo : '';
  // console.log(logo);
  const dispatch = useDispatch();

  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: logInRequest,
  } = useHttp();

  const emailRef = useRef();
  const passwordRef = useRef();

  const responseHandle = (response) => {
    saveLocalData("vidamaze_user", response);
    dispatch(
      authActions.login({
        token: response.token,
        roles: response.roles,
        first_name: response.first_name,
        last_name: response.last_name,
        access: response.access,
        email: response.email,
        video_credits: response.video_credits,
      })
    );
    history.push("/");
  };

  const submitHandler = (event) => {
    event.preventDefault();

    if (!emailState.isValid) {
      emailRef.current.focus();
      dispatchEmail({ type: "USER_INPUT_BLUR" });
    } else if (!passwordState.isValid) {
      passwordRef.current.focus();
      dispatchPassword({ type: "USER_INPUT_BLUR" });
    }

    if (emailState.isValid && passwordState.isValid) {
      const userData = {
        username: emailState.value,
        password: passwordState.value,
        subdomain_id: subdomain_id
      };

      logInRequest(
        {
          url: endPoints.login,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: userData,
        },
        responseHandle
      );
    }
  };

  const emailChangeHandler = (event) => {
    dispatchEmail({ type: "USER_INPUT", value: event.target.value });
  };

  const validateEmail = () => {
    dispatchEmail({ type: "USER_INPUT_BLUR" });
  };

  const passwordChangeHandler = (event) => {
    dispatchPassword({ type: "USER_INPUT", value: event.target.value });
  };

  const validatePassword = () => {
    dispatchPassword({ type: "USER_INPUT_BLUR" });
  };

  useEffect(() => {
    // console.log(httpStatusCode);

    if (error && httpStatusCode) {
  
      //  let icon  = httpStatusCode === 404 ? "fa-user-slash" : "fa-key";
      //  console.log(icon)
      // dispatch(
      //   alertAction.showAlert({
      //     action: "show",
      //     alert_txt: error,
      //     alert_class: "danger",
      //     alert_icon: icon,
      //   })
      // );
      setError(null);
      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "",
      });
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--main-color', '#333c59'); //#908fa1 text color
    root.style.setProperty('--btn-bg-color', '#ff3987'); //#904ece button background color
    root.style.setProperty('--btn-bg-hover-color', '#ff0266'); // #904ece, #d85993 Button background color on hover

    if(subdomain_name === 'vidwise'){
      root.style.setProperty('--main-color', '#9C6260'); // text color
      root.style.setProperty('--btn-bg-color', '#1f0403'); // button background color
      root.style.setProperty('--btn-bg-hover-color', '#523836'); //Button background color on hover
    }

    if(subdomain_name === 'nicheflick'){
      root.style.setProperty('--main-color', '#0F1225'); // text color
      root.style.setProperty('--btn-bg-color', '#3C9DF3'); // button background color
      root.style.setProperty('--btn-bg-hover-color', '#0F1225'); //Button background color on hover
    }

    
    
  }, [subdomain_name]);
  
  return (
    <>

      <style>
        {
          (subdomain_name === 'nicheflick' && 
            `
            .login_m .overlay {
              background-color: #3C9DF3!important;
            }
            `
          )
        }
      </style>


      <form onSubmit={submitHandler} method="post">
        
        { logo && <img
          src={logo}
          className="img-fluid"
          alt="img"
          />
        }

        <h1 className="p2">Sign in</h1>
        {/* <span>or use your account</span> */}
        {error && <h3>{error}</h3>}
        <Input
          ref={emailRef}
          type="email"
          placeholder="Enter Your Email"
          onChange={emailChangeHandler}
          onBlur={validateEmail}
          inputClass={`${
            emailState.isValid === false ? "invalid" : ""
          } rounded`}
        />
        <Input
          ref={passwordRef}
          type="password"
          placeholder="Enter Your Password"
          onChange={passwordChangeHandler}
          onBlur={validatePassword}
          inputClass={`${
            passwordState.isValid === false ? "invalid" : ""
          } rounded`}
        />
        <button type="submit">Sign In</button>
      </form>
    </>
  );
};

export default Login;
